// Number, money and date formatting shared by the admin tabs.

const nf = new Intl.NumberFormat('sv-SE');

export const isBlank = (value) => value === null || value === undefined || value === '';
export const fmt = (value) => (isBlank(value) ? '—' : nf.format(value));
export const kr = (value) => (value ? `${nf.format(value)} kr` : '—');
export const pct = (part, total) => (total ? `${Math.round((100 * part) / total)}%` : '—');
export const toNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
};

export const TYPE_LABEL = { apartment: 'Apartment', house: 'House', 'house++': 'Townhouse / semi' };
export const typeLabel = (type) => TYPE_LABEL[type] || type || '—';

export const UPCOMING_TAG = 'Snart till salu';
export const BIDDING_TAG = 'Budgivning pågår';

export const duration = (seconds) => {
    if (seconds === undefined || seconds === null) return '—';
    if (seconds < 90) return `${Math.round(seconds)} s`;
    if (seconds < 5400) return `${(seconds / 60).toFixed(1)} min`;
    return `${(seconds / 3600).toFixed(1)} h`;
};

export const formatDateTime = (value) => {
    if (!value) return '—';
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return String(value);
    return new Intl.DateTimeFormat('sv-SE', { dateStyle: 'medium', timeStyle: 'short' }).format(parsed);
};

export const JOB_KIND_LABEL = { full_scan: 'Full scan', new_scan: 'New listings', sold: 'Sold listings' };
export const jobKindLabel = (job) => {
    const label = JOB_KIND_LABEL[job?.kind] || job?.kind || 'Job';
    const days = job?.options?.days;
    return days ? `${label} · last ${days} days` : label;
};

// The image CDN serves the same photo in several widths; the DB stores the 1440px one.
export const smallImage = (url) => String(url || '').replace('_1440x0', '_294x0');
